'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.promise.try.js');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/esnext.promise.try.js
// module id = 738
// module chunks = 13